import { ReservationItem } from '@/root/shared-types'
import Image from 'next/image'
import { FC } from 'react'
import { useGetTranslations, useIsMobile, useSetQrImgSrc, useScrollToRef } from '@/root/shared-hooks'
import { testIds } from '@/root/shared-consts'

interface TicketItemsWithQRProps {
  items: ReservationItem[]
  reservationId: number
  sailRefId: number
  hideQrCode?: boolean
}

const TicketItemsWithQR: FC<TicketItemsWithQRProps> = ({ items, reservationId, sailRefId, hideQrCode }) => {
  const isMobile = useIsMobile()
  const { getTranslation } = useGetTranslations()
  const { qrImgSrc } = useSetQrImgSrc({ sailRefId, reservationId })
  const { ref } = useScrollToRef(qrImgSrc)

  const length = isMobile ? 350 : 150

  return (
    <div className="ticket-print-avoid-break flex flex-col items-start py-5 text-xl md:flex-row md:justify-between">
      <div className="flex flex-col">
        {items.map(({ priceCategoryTranslation, quantity }) => {
          return (
            <div key={priceCategoryTranslation}>
              {quantity} x {priceCategoryTranslation}
            </div>
          )
        })}
      </div>
      {qrImgSrc && !hideQrCode && (
        <div data-testid={testIds.printedTicket.qrCode} className="self-center" ref={ref}>
          {/* unoptimized: the Next.js image optimizer fetches a local src with a request that has no headers, and the
              trial storefront names its tenant by Host. The QR route already sends a ready PNG. */}
          <Image alt={getTranslation('ticketQrCodeAlt')} src={qrImgSrc} width={length} height={length} unoptimized />
        </div>
      )}
    </div>
  )
}

export default TicketItemsWithQR
